module.exports = __webpack_public_path__ + "img/complete-vehicle.888ff61e.png";